export default __webpack_public_path__ + "static/media/plant_placeholder.832f4597.jpg";